import { configureStore } from "@reduxjs/toolkit";
import tokenSlice from "./tokenSlice";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import cartListSlice from "./cartListSlice";
import { combineReducers } from "redux";
import showLogModalSlice from "./showLogModalSlice";
import categorySlice from "./categorySlice";
import orderNumberSlice from "./orderNumberSlice";

const rootReducer = combineReducers({
  token: tokenSlice,
  cartList: cartListSlice,
  showLogModal: showLogModalSlice,
  category: categorySlice,
  orderNumber: orderNumberSlice,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const Persistor = persistStore(store);

export { Persistor };
export default store;
